import { generateId } from '@freelancer/datastore/testing/helpers';
import type { DateApi } from 'api-typings/common/common';
import { format } from 'date-fns';
import type { TimeTrackingDailyAggregate } from './time-tracking-daily-aggregates.model';

export interface GenerateTimeTrackingDailyAggregateOptions {
  readonly bidId: number;
  readonly date: DateApi;
  readonly totalTimeTracked: number;
}

export function generateTimeTrackingDailyAggregate({
  bidId,
  date,
  totalTimeTracked,
}: GenerateTimeTrackingDailyAggregateOptions): TimeTrackingDailyAggregate {
  return {
    id: generateId().toString(),
    bidId,
    date,
    totalTimeTracked,
    dateString: format(
      new Date(date.year, date.month - 1, date.day),
      'yyyy-MM-dd',
    ),
  };
}
